module.exports = __webpack_public_path__ + "media/polypoid tumor.f6b9a94b.wav";